export default "__VITE_ASSET__a25ef111__"